import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./loves_concept.js";
//#region src/loves_concept_helper.ts
var loves_concept_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(lovesConcept) {
	switch (lovesConcept) {
		case "express-checkout": return "Express Checkout";
		case "godfathers-pizza": return "Godfather's Pizza";
		case "subway": return "Subway";
	}
}
//#endregion
export { loves_concept_helper_exports, name };

//# sourceMappingURL=loves_concept_helper.js.map